import gql from 'graphql-tag';

export default gql`
  query getModelosNotasFiltradas($filtro: String = "") {
    getModelosNotasFiltradas(filtro: $filtro) {
      _id
      titulo
      descripcion
      htmlModelo
      #      talonarios {
      #        talonario {
      #          _id
      #          nombre
      #          cantidad
      #        }
      #        organismo {
      #          _id
      #          nombre
      #        }
      #      }
      #      organismos {
      #        _id
      #        nombre
      #      }
      #      clasificadoresEstadisticos {
      #        _id
      #        nombre
      #        descripcion
      #      }
    }
  }
`;
